module.exports = __webpack_public_path__ + "static/section_3_2-a8b0628bf9aae57472d69e7098744d2b.png";